import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorSettings,
  isEmpty,
  type FormValidatorContext
} from '@common';
import { storeToRefs } from 'pinia';
import { useStatisticsWizardStore } from '../stores';

export type SourceYearSettings = FormValidatorSettings;

export type SourceYearConfig = FormValidatorConfig<SourceYearSettings>;

export class SourceYearValidator extends FormValidator<SourceYearSettings> {
  constructor() {
    super();
    this._name = 'sourceYear';
    this._settings = {
      invalidMessage: 'sourceYear.validator.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value) || !context.element.enabled) {
      return;
    }

    const wizardStore = useStatisticsWizardStore();
    const { statisticsData } = storeToRefs(wizardStore);

    if (statisticsData.value && statisticsData.value.year !== value.year) {
      this.addMessage(this._settings.invalidMessage, 'warning');
    }

    this.valid = true;
  }
}
